import React from "react";

import EmailVerificationInfo from "./EmailVerificationInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import ListBody from "./ListBody";
import { FormattedMessage } from "react-intl";
import DeleteResourceButton from "./DeleteResourceButton";
import { Table, TableCell, TableHead, TableRow } from "@mui/material";

type UserEmailsTableProps = {
    rows: any[];
};

const UserEmailsTable: React.FC<UserEmailsTableProps> = ({ rows }) => {
    let idsWithoutToken = [];
    for (let row of rows) {
        if (row["tokens"].length == 0) idsWithoutToken.push(row.id);
    }
    let deleteDisabled = idsWithoutToken.length == 1 ? idsWithoutToken[0] : 0;

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>
                        <FormattedMessage id="user_email.address" />
                    </TableCell>
                    <TableCell>
                        <FormattedMessage id="user_email.verified" />
                    </TableCell>
                    <TableCell />
                    <TableCell />
                </TableRow>
            </TableHead>
            <ListBody
                data={rows}
                header={["address", "tokens", "verificationInfo", "controls"]}
                renderers={{
                    tokens: (val, data) => {
                        const icon = data.tokens.length ? (
                            <FontAwesomeIcon icon={faTimes} color="red" />
                        ) : (
                            <FontAwesomeIcon icon={faCheck} color="green" />
                        );
                        return <div style={{ textAlign: "center" }}>{icon}</div>;
                    },
                    verificationInfo: (val, data) => {
                        if (data.tokens.length) return <EmailVerificationInfo data={data} />;
                        return null;
                    },
                    controls: (val, data) => {
                        let disabled = data.id == deleteDisabled;
                        return (
                            <DeleteResourceButton
                                resourceName="user_email"
                                tooltip={disabled ? <FormattedMessage id="user_email.disabled_of_one" /> : null}
                                disabled={disabled}
                                id={data.id}
                            />
                        );
                    },
                }}
            />
        </Table>
    );
};

export default UserEmailsTable;
